import { OnboardingDto } from '~/interfaces/Dto/OnboardingDto';
import OnboardingStatus from '~/interfaces/OnboardingStatus';
import { OnboardingData } from '~/interfaces/OnboardingData';

export default function transformOnboarding(dto: OnboardingDto): OnboardingData {
  const value = dto?.data?.onboardingStatus;
  let status: OnboardingStatus = OnboardingStatus.Inactive;

  if (typeof value === 'string') {
    const match = Object.values(OnboardingStatus).find(
      (statusValue) =>
        typeof statusValue === 'string' &&
        statusValue.toLowerCase() === value.toLowerCase(),
    );
    if (match) {
      status = match as OnboardingStatus;
    }
  }

  return {
    status,
    proposedUsername: dto?.data?.proposedUsername ?? '',
    proposedUsernameMandatory: dto?.data?.proposedUsernameMandatory ?? false,
  };
}
